<template>
  <div class="row inline">
    <label for="email" class="col-md-1 col-form-label">Email</label>
    <div class="col-md-3">
      <input v-model="email" type="text" class="form-control" id="email" />
    </div>
    <div class="col-md-3 col-form-label">
      <input v-model="includeSearchFromSubscriptionMetabase" type="checkbox" class="form-check-input"
        id="includeSearchFromSubscriptionMetabase" />&nbsp;
      <label class="form-check-label">Show Other Emails</label>
    </div>
    <div class="col-md-3">
      <button v-on:click="findUser()" type="button" class="btn btn-primary">Search</button>
    </div>
  </div>
  <div>
    <span>{{ message }}</span>
  </div>
  <div class="row d-flex flex-row-reverse" style="margin-bottom: 10px">
    <div class="col-md-1 float-right">
      <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
        <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off"
          v-on:change="setDisplayMode('grid')" />
        <label class="btn btn-outline-primary" for="btnradio1"><i class="bi bi-grid"></i></label>

        <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" checked
          v-on:change="setDisplayMode('table')" />
        <label class="btn btn-outline-primary" for="btnradio2"><i class="bi bi-table"></i></label>
      </div>
    </div>
  </div>
  <div class="row" v-if="displayMode === 'grid'">
    <UsersGrid :users="users" />
  </div>
  <div class="row" v-if="displayMode === 'table'">
    <UsersTabular :users="users" @loadEmailChange="loadEmailChange" @loadUserUnlock="loadUserUnlock" />
  </div>
  <div class="row" style="margin-top: 20px;" v-if="includeSearchFromSubscriptionMetabase">
    <UserSubscriptionsTabular :subscriptions="subscriptions" />
  </div>
  <div class="modal fade" id="changeEmailModal" tabindex="-1" role="dialog" aria-labelledby="changeEmailModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="changeEmailModalLabel">Change Email</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="row mb-3">
              <label for="inputEmail3" class="col-sm-3 col-form-label">Current Email</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="oldEmail" v-model="email" disabled />
              </div>
            </div>
            <div class="row mb-3">
              <label for="inputPassword3" class="col-sm-3 col-form-label">New Email</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="newEmail" v-model="newEmail" />
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" v-on:click="changeEmail()">Yes</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="unlockUserModal" tabindex="-1" role="dialog" aria-labelledby="unlockUserModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="unlockUserModalLabel">Unlock User</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Are you sure to unlock <strong>{{ email }}</strong>?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" v-on:click="unlockUser()">Yes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiClient } from '../../helpers/api-client';
import { HTTP_METHODS, HTTP_STATUS_CODES } from '../../helpers/config';
import UsersTabular from '@/components/UsersTabular.vue';
import UsersGrid from '@/components/UsersGrid.vue';
import UserSubscriptionsTabular from '@/components/UserSubscriptionsTabular.vue';
let changeEmailModal;
let unlockUserModal;
export default {
  name: 'Users',
  components: {
    UsersTabular,
    UsersGrid,
    UserSubscriptionsTabular
  },
  data() {
    return {
      displayMode: 'table',
      email: '',
      userId: '',
      oldEmail: '',
      newEmail: '',
      emailToUnlock: '',
      message: '',
      users: [],
      includeSearchFromSubscriptionMetabase: false,
      subscriptions: []
    };
  },
  created() {
    this.email = this.$route.query.email;
  },
  async mounted() {
    changeEmailModal = new bootstrap.Modal(document.getElementById('changeEmailModal'), {
      keyboard: false
    });
    unlockUserModal = new bootstrap.Modal(document.getElementById('unlockUserModal'), {
      keyboard: false
    });
    await this.findUser();
  },
  methods: {
    setDisplayMode(mode) {
      this.displayMode = mode;
    },
    loadEmailChange(userId, email) {
      this.oldEmail = email;
      this.userId = userId;
      changeEmailModal.show();
    },
    loadUserUnlock(userId, email) {
      this.emailToUnlock = email;
      this.userId = userId;
      unlockUserModal.show();
    },

    findUser: async function () {
      if (!this.email) {
        return;
      }
      const usersResults = await apiClient(
        `users`,
        HTTP_METHODS.GET,
        {},
        { redirectOnUnauthorized: true },
        {
          // we don't have users with same domain with more than the below number and try to limit the number fetched here
          filter: { where: { email: { ilike: `%${this.email}%` } }, limit: 30 }
        }
      );
      if (usersResults.status === HTTP_STATUS_CODES.SUCCESS) {
        this.users = usersResults.data;
        this.message = usersResults.data.length === 0 ? `Unable to find user with ${this.email}.` : '';
      }

      if (this.includeSearchFromSubscriptionMetabase) {
        const subscriptionResults = await apiClient(
          `subscriptions/findByChargebeeCustomerEmail/${this.email}`,
          HTTP_METHODS.GET,
          {},
          { redirectOnUnauthorized: true }
        );
        if (subscriptionResults.status === HTTP_STATUS_CODES.SUCCESS) {
          this.subscriptions = subscriptionResults.data;
        }
        console.log(this.subscriptions[0]);
      }
    },
    unlockUser: async function () {
      if (this.email) {
        const result = await apiClient(`users/${this.userId}/unlockuser`, HTTP_METHODS.POST, {
          email: this.emailToUnlock
        });
        if (result.status === HTTP_STATUS_CODES.NO_CONTENT) {
          unlockUserModal.hide();
          this.message = 'User has been locked successfully.';
        }
      }
    },
    changeEmail: async function () {
      if (this.email && this.newEmail) {
        const result = await apiClient(`users/${this.userId}/changeemail`, HTTP_METHODS.POST, {
          oldEmail: this.oldEmail,
          newEmail: this.newEmail
        });
        if (result.status === HTTP_STATUS_CODES.NO_CONTENT) {
          changeEmailModal.hide();
          this.message = 'Email has been changed successfully.';
        }
      }
    }
  }
};
</script>
